
<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img :src="require('@/assets/images/pages/Forgot password.svg')" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Reset your password</h4>
                                    <p>Please enter your email address and we'll send you instructions on how to reset your password.</p>
                                </div>
                                <vs-input id="email" @keypress.enter="RecoverPassword" type="email" label-placeholder="Email" v-model="email_address" class="w-full mb-8" />
                                <vs-button type="link" to="/login" class="px-4 w-full back-to-login md:w-auto font-semibold">Login</vs-button>
                                <vs-button @click="RecoverPassword" :disabled="!dateExpired ? false : disabledButton" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">Reset Password</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import axios from '@/axios'
import moment from 'moment'
import mixin from '@/views/mixin/mixin'
export default {
  mixins: [mixin],
  data () {
    return {
      email_address: '',
      dateExpired: null
    }
  },
  methods:{
    async RecoverPassword(){
      try{
        this.$vs.loading()
        const { data } = await axios.post('/account/forgot/',{ email_address:this.email_address })
        console.log(this.current_date > data.timeRes,this.current_date, data.timeRes,'data.timeRes')
        this.dateExpired = data.timeRes
        this.$ntSuccess('please check your Email to reset password.')
      }catch (e){
        this.$ntSetError('warning',e.data)
      }finally {
        this.$vs.loading.close()
      }
    },
    focusField(){
      document.getElementById('email').focus()
    },
    disabledButton() {
      console.log(this.dateExpired,'this.dateExpired')
      if (this.dateExpired)
        return this.dateExpired > this.current_date
      return true
    }
  },
  mounted() {
    this.focusField()
  }
}
</script>

<style>
[dir] .vx-row{
  margin: 0 !important;
}
.back-to-login .vs-button-text.vs-button--text{
  color: #5b3cc4 !important;
}
</style>
